import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectIsSpecialProjectAdfoxBannerVisible } from 'shared/selectors/results/selectIsSpecialProjectAdfoxBannerVisible';
import { selectSpecialPromoBuilderOffers } from 'shared/selectors/results/selectSpecialPromoBuilderOffers';

import { SpecialProjectBanner } from '../AdfoxBanner';

import { SpecialProjectCarousel } from './internal/components/SpecialProjectCarousel';
import { trackSpecialPromosDataReceived } from './internal/tracking/trackSpecialPromosDataReceived';

export const SpecialProject: FC = () => {
  const specialPromoBuilderOffers = useSelector(selectSpecialPromoBuilderOffers);
  const isSpecialProjectAdfoxBannerVisible = useSelector(selectIsSpecialProjectAdfoxBannerVisible);

  useEffect(() => {
    if (isSpecialProjectAdfoxBannerVisible) {
      trackSpecialPromosDataReceived({ viewType: 'banner' });
    } else if (specialPromoBuilderOffers) {
      trackSpecialPromosDataReceived({ viewType: 'carousel' });
    }
  }, [specialPromoBuilderOffers, isSpecialProjectAdfoxBannerVisible]);

  if (isSpecialProjectAdfoxBannerVisible) {
    return <SpecialProjectBanner />;
  }

  if (specialPromoBuilderOffers) {
    return (
      <SpecialProjectCarousel
        allOffersUrl={specialPromoBuilderOffers.allOffersUrl}
        builder={specialPromoBuilderOffers.builder}
        offers={specialPromoBuilderOffers.offers}
      />
    );
  }

  return null;
};
